const routes = [
  {
    path: "/manutencao-de-disciplina-afins",
    name: "manutencao-de-disciplina-afins",
    meta: {
      allowedPermissions: ["disciplinas_afins_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDeDisciplinaAfins/ManutencaoDeDisciplinaAfinsHome.vue"
      ),
  },
  {
    path: "/manutencao-de-disciplina-afins/novo",
    name: "manutencao-de-disciplina-afins-novo",
    meta: {
      allowedPermissions: ["disciplinas_afins_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDeDisciplinaAfins/ManutencaoDeDisciplinaAfinsCad.vue"
      ),
  },
  {
    path: "/manutencao-de-disciplina-afins/editar/:id",
    name: "manutencao-de-disciplina-afins-editar",
    meta: {
      allowedPermissions: ["disciplinas_afins_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDeDisciplinaAfins/ManutencaoDeDisciplinaAfinsEdit.vue"
      ),
  },
];

export default routes;
